import ajax from "../assets/uilt/ajax";
export default {
  /**bind Devices */
  getPage: req => {
    return ajax.get({
      url: "/back/customer-device/get-page",
      param: req.param,
      success: req.success
    });
  },

  /**unbind Devices */
  unBindDevice: req => {
    return ajax.post({
      url: "/back/customer-device/unbind-device",
      param: req.param,
      success: req.success
    });
  }

  //
};
